import IconCar from '../../assets/icons/icon-car.svg'
import React, { lazy, useEffect } from 'react'
import IconBedroom from '../../assets/icons/icon-bedroom.svg'
import IconRuler from '../../assets/icons/icon-ruler.svg'
// import { MapPin } from 'phosphor-react'
import { Link } from 'react-router-dom'
import SkeletonLoading from '../common/SkeletonLoading'
import { Suspense, useState } from 'react'
import enterpriseApi from '../../store/reducers/enterprise/enterpriseApi'
import {
  BEDROOM,
  DORMITORY,
  PARKING_SPACES,
  ROOMS
} from '../../constants/enterpriseSpecificationsTypes'
import statusApi from '../../store/reducers/status/statusApi'
import { CardFormContactLead } from '../Cards/CardFormContactLead'
import { v4 } from 'uuid'

interface EnterpriseDetailCard {
  Id: string | undefined
  ConstructionCompanyId: string | undefined
  Description: string | undefined
  StatusId: string | undefined
}

export default function BaseInfos({
  Id,
  Description,
  ConstructionCompanyId,
  StatusId
}: EnterpriseDetailCard) {
  const [openShareModal, setOpenShareModal] = useState(false)
  const [parkingSpaces, setParkingSpaces] = useState(0)
  const [rooms, setRooms] = useState<number[]>([])

  const {
    data: dataTipologies,
    isError: isErrorTipologies,
    isLoading: isLoadingTipologies,
    isSuccess: isSuccessTipologies,
    status: statusTipologies,
    error: errorTipologies
  } = enterpriseApi.useGetEnterpriseTipologiesByIdQuery(Id ?? '')

  const {
    data: dataInfo,
    isError: isErrorInfo,
    isLoading: isLoadingInfo,
    isSuccess: isSuccessInfo,
    status: statusInfo,
    error: errorInfo
  } = enterpriseApi.useGetEnterpriseInformationByIdQuery(Id ?? '')

  const handleShareModal = () => {
    setOpenShareModal(!openShareModal)
  }

  useEffect(() => {
    if (isSuccessTipologies) getTipologies()
  }, [isSuccessTipologies])

  const getTipologies = () => {
    var list: number[] = []
    if (dataTipologies != undefined && dataTipologies.Data.length > 0) {
      dataTipologies?.Data.forEach((element) => {
        if (element.Specification.Type === PARKING_SPACES) {
          setParkingSpaces(element.Specification.Quantity)
        }
        if (
          element.Specification.Type === DORMITORY ||
          element.Specification.Type === ROOMS ||
          element.Specification.Type === BEDROOM
        ) {
          list.push(element.Specification.Quantity)
        }
      })
    }

    list = [...new Set(list)]
    list.sort()
    setRooms(list)
  }

  const isValidTotalArea = () => {
    if (isSuccessInfo) {
      try{
        let isValid = dataInfo.Data && dataInfo.Data.TotalAreaBuilder && parseInt(dataInfo.Data.TotalAreaBuilder) != 0
        return isValid
      }catch{
        return false
      }
    }
    return false
  }

  return (
    <>
      <div className="grid gap-4">
        <div className="flex items-center gap-3 fw-normal">
          <Suspense fallback={<SkeletonLoading />}>
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              className='inline'
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_10136_14485)">
                <path
                  d="M17.5333 7.16001H8.73333C8.28889 7.16001 7.86667 7.29334 7.46667 7.56001C7.37778 6.89334 7.1 6.3489 6.63333 5.92668C6.16667 5.50445 5.62222 5.29334 5 5.29334C4.51111 5.29334 4.06667 5.40445 3.66667 5.62668V4.62668C3.66667 4.4489 3.61111 4.30445 3.5 4.19334C3.38889 4.08223 3.24444 4.02668 3.06667 4.02668H0.6C0.422222 4.02668 0.277778 4.08223 0.166667 4.19334C0.0555556 4.30445 0 4.4489 0 4.62668V17.16C0 17.3378 0.0555556 17.4822 0.166667 17.5933C0.277778 17.7045 0.422222 17.76 0.6 17.76H3.06667C3.24444 17.76 3.38889 17.7045 3.5 17.5933C3.61111 17.4822 3.66667 17.3378 3.66667 17.16V15.2267H16.3333V17.16C16.3333 17.3378 16.3889 17.4822 16.5 17.5933C16.6111 17.7045 16.7556 17.76 16.9333 17.76H19.4C19.5778 17.76 19.7222 17.7045 19.8333 17.5933C19.9444 17.4822 20 17.3378 20 17.16V9.62668C20 8.96001 19.7556 8.38223 19.2667 7.89334C18.7778 7.40445 18.2 7.16001 17.5333 7.16001ZM5 6.42668C5.35556 6.42668 5.65556 6.56001 5.9 6.82668C6.14444 7.09334 6.26667 7.40445 6.26667 7.76001C6.26667 8.11556 6.14444 8.41556 5.9 8.66001C5.65556 8.90445 5.35556 9.02668 5 9.02668C4.64444 9.02668 4.33333 8.90445 4.06667 8.66001C3.8 8.41556 3.66667 8.11556 3.66667 7.76001C3.66667 7.40445 3.8 7.09334 4.06667 6.82668C4.33333 6.56001 4.64444 6.42668 5 6.42668ZM3.66667 9.82668C4.06667 10.0933 4.5 10.2267 4.96667 10.2267C5.43333 10.2267 5.86667 10.0933 6.26667 9.82668V11.56H3.66667V9.82668ZM18.8 16.56H17.4667V14.6267C17.4667 14.4933 17.4111 14.3711 17.3 14.26C17.1889 14.1489 17.0667 14.0933 16.9333 14.0933H3.06667C2.93333 14.0933 2.81111 14.1489 2.7 14.26C2.58889 14.3711 2.53333 14.4933 2.53333 14.6267V16.56H1.2V5.22668H2.53333V12.16C2.53333 12.2933 2.58889 12.4267 2.7 12.56C2.81111 12.6933 2.93333 12.76 3.06667 12.76H18.8V16.56ZM18.8 11.56H7.46667V9.62668C7.46667 9.27112 7.58889 8.97112 7.83333 8.72668C8.07778 8.48223 8.37778 8.36001 8.73333 8.36001H17.5333C17.8889 8.36001 18.1889 8.48223 18.4333 8.72668C18.6778 8.97112 18.8 9.27112 18.8 9.62668V11.56Z"
                  fill="#1A1A1A"
                  fill-opacity="0.45"
                />
              </g>
              <defs>
                <clipPath id="clip0_10136_14485">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="matrix(1 0 0 -1 0 20.8933)"
                  />
                </clipPath>
              </defs>
            </svg>
          </Suspense>
          <span className="text-base lg:text-xl text-[#52525B]">
            Apartamentos com{' '}
            <span className="fw-bold">
              {rooms.length > 1 ? rooms[0] + ' a ' + rooms[rooms.length - 1] : rooms[0]} quarto(s)
            </span>
          </span>
        </div>
        <div className="flex items-center gap-3 fw-normal">
          <Suspense fallback={<SkeletonLoading />}>
            <img alt="Car Icon" src={IconCar} className="w-[20px] h-[20px] inline opacity-50" />
          </Suspense>
          <span className="text-base lg:text-xl text-[#52525B]">
            <span className="fw-bold">
              {parkingSpaces} vaga{parkingSpaces <= 1 ? '' : '(s)'}
            </span>{' '}
            de garagem
          </span>
        </div>
        {isValidTotalArea() && <div className="flex items-center gap-3 fw-normal">
          <Suspense fallback={<SkeletonLoading />}>
            <img alt="Ruler Icon" src={IconRuler} className="w-[20px] h-[20px] inline opacity-50" />
          </Suspense>
          <span className="text-base lg:text-xl text-[#52525B]">
            Plantas de{" "}
            <span className="fw-bold">
              {isErrorInfo && <>Não informado</>}
              {isSuccessInfo && <>{dataInfo?.Data.TotalAreaBuilder} {dataInfo?.Data.TotalAreaBuilder.includes("m²") ? "" : "m²"}</>}
            </span>
          </span>
        </div>}

      </div>
    </>
  )
}
